import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

function mapHistoryItemFromApi(d) {
  return {
    id: d.id,
    title: d.title ?? '',
    description: d.description ?? '',
    branch: d.branch ?? '',
    creator: d.creator ?? '',
    date: d.date ?? '',
    status: d.status ?? 'pending',
    deadline: d.deadline ?? '',
    votes: Array.isArray(d.votes) ? d.votes : [],
    totalMembers: d.totalMembers ?? 0,
    myVote: d.myVote ?? null,
    myNote: d.myNote ?? '',
    myVotedAt: d.myVotedAt ?? '',
  };
}

export async function fetchMemberVoteHistory() {
  const res = await fetch(`${API_BASE}/api/member/decisions/history`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل سجل التصويت'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapHistoryItemFromApi);
}
